import React from 'react';
import { Button,Modal, Row, Col, Spin } from 'antd';
import API_URL from '../../common/url';
import AjaxRequest from '../../common/AjaxRequest';

class UserDetail extends React.Component {
    state = {
        visible: false,
        loading: false,
        user: {},
    }

    show = (userId, extraData = {}) => {
        this.setState({ visible: true }, () => {
            this.queryDetail(userId, extraData);
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    queryDetail = (userId, extraData = {}) => {
        this.setState({ loading: true });
        const options = {
            url: `${API_URL.user.getUserDetail}`,
            data: { userId, ...extraData },
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    loading: false,
                    user: res.data.userInfo,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        AjaxRequest.sendRequest(options);
    }

    render() {
        const { visible, loading, user } = this.state;
        const { userName, employeeCode, positionName, leader, mobile, email, enterpriseDepartmentName } = user;
        return (
            <Modal
                title='人员信息'
                visible={visible}
                onCancel={this.hide}
                className="create-modal"
                wrapClassName="vertical-center-modal"
                width="400px"
                footer={[<Button key="back" type="primary" size="large" onClick={this.hide}>关闭</Button>]}
            >
                <Spin spinning={loading}>
                    <Row>
                        <Col span={9} style={{textAlign: 'right'}}>工号:</Col>
                        <Col span={14} offset={1}>{employeeCode || ''}</Col>
                    </Row>
                    <Row>
                        <Col span={9}  style={{textAlign: 'right'}}>姓名:</Col>
                        <Col span={14} offset={1}>{userName || ''}</Col>
                    </Row>
                    <Row>
                        <Col span={9}  style={{textAlign: 'right'}}>职位/级别:</Col>
                        <Col span={14} offset={1}>{positionName || ''}</Col>
                    </Row>
                    <Row>
                        <Col span={9}  style={{textAlign: 'right'}}>主管领导:</Col>
                        <Col span={14} offset={1}>{leader ? leader.userName : ''}</Col>
                    </Row>
                    <Row>
                        <Col span={9}  style={{textAlign: 'right'}}>部门:</Col>
                        <Col span={14} offset={1}>{enterpriseDepartmentName || ''}</Col>
                    </Row>
                    <Row>
                        <Col span={9}  style={{textAlign: 'right'}}>手机号码:</Col>
                        <Col span={14} offset={1}>{mobile || ''}</Col>
                    </Row>
                    <Row>
                        <Col span={9}  style={{textAlign: 'right'}}>邮箱:</Col>
                        <Col span={14} offset={1}>{email || ''}</Col>
                    </Row>
                </Spin>
            </Modal>
        )
    }
}

export default UserDetail;



// WEBPACK FOOTER //
// ./src/components/investigation/UserDetail.js